/** CRE Floating Transcriber — Chrome Web Store */
export const CRE_EXTENSION_STORE_URL =
  "https://chromewebstore.google.com/detail/mnjepkenmkkimimnedopigmagfpngklh";
